import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  ShieldCheck, Truck, MapPin, BadgeCheck, Sparkles, Phone, Mail,
  Star, Clock, Quote, Bed, Activity, Users, Briefcase, Heart, ArrowRight, Tag, Ruler, Award,
  Layers, Wind, ShieldOff, Droplets, Leaf, ExternalLink, Navigation, Package, ShoppingBag, MessageCircle, Zap,
} from "lucide-react";
import LeadForm from "@/components/LeadForm";
import VideoCard from "@/components/VideoCard";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const LOGO = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/jyhdvnlr_logo-png-cuadrado.png";
const HERO_IMG = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/ywlmq81c_colchon-core-1%20%282%29.jpg";
const TEXTURE_IMG = "https://static.prod-images.emergentagent.com/jobs/5176ddee-e136-4712-ba1c-64ebd4973fa4/images/d70f06af51d65637346507a41ccbf72451b6c9cdcd3ecac3e405523b03c35a15.png";
const STORE_IMG = "https://static.prod-images.emergentagent.com/jobs/5176ddee-e136-4712-ba1c-64ebd4973fa4/images/85ae8a9215790293b3e6db24f4cbde9ed27b318b907f2aef9344459e0856af66.png";
const PERSONA_ATHLETE = "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";
const PERSONA_COUPLE = "https://images.unsplash.com/photo-1758524941364-069f6ccd85ed?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";
const PERSONA_WORKER = "https://images.unsplash.com/photo-1713947503867-3b27964f042b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";
const PERSONA_WAREHOUSE = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/mnv8in8w_hombre.png";
const PERSONA_RETAIL = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/xs3xifni_mujer.png";

// === Vídeos del producto (mp4 directos) ===
const VIDEO_TECNOLOGIA = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/rn4sm296_descanso-colchon-core.mp4"; // 1:45 — responsable explica COREADAPT en tienda
const VIDEO_PAREJAS    = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/ldvtgdm9_CORE%20COLCHON%20IDEAL%20PARA%20PAREJAS.mp4"; // parejas
const VIDEO_REFUERZOS  = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/7bcww0jc_CAMBIO%20REFUERZOS%20VISCO.mp4"; // cambio de refuerzos
const VIDEO_COMPOSICION = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/kq7en2yd_composicion-core.mp4"; // composición / capas
const VIDEO_RESUMEN    = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/yed756e8_core-navalcarnero.mp4"; // 0:52 — animación resumen + 100 días

// === Imagen técnica corte del colchón ===
const ANATOMY_IMG = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/jpj77u1y_bg8-2_1.jpg";

// === Imagen cinematográfica dormitorio ===
const HERO_BEDROOM_IMG = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/g67jqsif_colchon-core.jpg";

// === Logo horizontal CORE COLCHÓN (versión wide) ===
const LOGO_WIDE = "https://customer-assets.emergentagent.com/job_media-insights-26/artifacts/8vi2gezw_logo-core-2.png";

// === Tienda física ===
const STORE_ADDRESS = "Calle Dehesa de Mari Martín, 27 (Autovía N-V), 28600 Navalcarnero, Madrid";
const STORE_MAPS_QUERY = "Calle Dehesa de Mari Martín 27, 28600 Navalcarnero, Madrid";
const STORE_MAPS_EMBED = `https://maps.google.com/maps?q=${encodeURIComponent(STORE_MAPS_QUERY)}&output=embed`;
const STORE_MAPS_LINK = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(STORE_MAPS_QUERY)}`;

const STANDARD_PRICES = [
  { size: "90×190",  price: 449 },
  { size: "90×200",  price: 449 },
  { size: "105×190", price: 529 },
  { size: "135×190", price: 649 },
  { size: "135×200", price: 649 },
  { size: "140×200", price: 687 },
  { size: "150×190", price: 687 },
  { size: "150×200", price: 687 },
  { size: "160×200", price: 814 },
  { size: "180×200", price: 914 },
  { size: "200×200", price: 949 },
];

const TESTIMONIALS = [
  { name: "María L.", text: "Llevamos un mes con el Core y dormimos del tirón. La atención en la tienda de Navalcarnero fue de 10.", stars: 5 },
  { name: "Javier R.", text: "Probarlo 100 noches en casa quita cualquier duda. Mi pareja prefiere más firme y yo más suave: solucionado.", stars: 5 },
  { name: "Lucía M.", text: "Lo más cómodo que hemos tenido. Y fabricado en España, eso sumó muchos puntos.", stars: 5 },
  { name: "Andrés P.", text: "Asesoramiento sin presión, te explican todo con calma. Aproveché el cheque y muy buen trato.", stars: 5 },
  { name: "Carmen V.", text: "Llegó rápido, lo subieron a casa y al día siguiente ya notaba la diferencia al levantarme.", stars: 5 },
  { name: "Tomás G.", text: "El detalle de poder cambiar la firmeza por dentro es brutal. Recomendado 100%.", stars: 5 },
];

const FAQS = [
  { q: "¿En qué consisten las 100 noches de prueba?",
    a: "Recibes el colchón Core en casa y lo pruebas en tu rutina real durante un máximo de 100 días (mínimo 30, periodo de adaptación). Si no es para ti, lo recogemos en tu domicilio sin coste y te devolvemos el 100% del importe." },
  { q: "¿Qué incluye la garantía de 10 años?",
    a: "10 años de garantía clara, sin letra pequeña, contra defectos de fabricación. Además contamos con un plan renove muy interesante." },
  { q: "¿Dónde se fabrica el colchón Core?",
    a: "Core se fabrica íntegramente en España, con proveedores españoles. Generamos empleo y pagamos nuestros impuestos aquí." },
  { q: "¿Cuánto cuesta el envío y la posible devolución?",
    a: "El envío es siempre gratuito. En provincia de Madrid lo subimos y lo montamos también gratis. Si decides devolverlo dentro de las 100 noches, la recogida también es gratuita." },
  { q: "¿Cómo funciona la regulación de firmeza?",
    a: "Core incluye refuerzos intercambiables en la zona central (zona Core) que te permiten ajustar la firmeza tantas veces como quieras y, en medidas grandes, de forma independiente para cada lado de la cama." },
  { q: "¿Sirve para parejas con pesos o gustos distintos?",
    a: "Sí. En medidas a partir de 135 cm cada lado puede tener su propia firmeza. Y como el núcleo es viscoelástico de calidad, hay independencia de lechos: no notarás los movimientos de tu pareja." },
  { q: "¿Cuánto tarda la entrega?",
    a: "2–5 días laborables en medidas estándar y 10–15 días en medidas especiales, desde la confirmación del pedido." },
  { q: "¿Cómo canjeo el cheque de 100€?",
    a: "Recibes el cheque por email tras solicitarlo. Un asesor te llamará para reservarte hora y, cuando vengas a la tienda de Navalcarnero, lo presentas para descontar 100€ en tu colchón Core." },
];

function StarRow({ n = 5 }) {
  return (
    <div className="flex gap-0.5 text-[#E0A500]">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} size={14} className={i < n ? "fill-current" : "opacity-25"} />
      ))}
    </div>
  );
}

function Header() {
  return (
    <header className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-[#E3DDE8]/70">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 h-24 flex items-center justify-between">
        <a href="#top" className="flex items-center" data-testid="header-logo">
          <img src={LOGO_WIDE} alt="Core Colchón" className="h-14 sm:h-16 w-auto object-contain" />
        </a>
        <nav className="hidden md:flex items-center gap-7 text-sm text-[#5C5366]">
          <a href="#tecnologia" className="hover:text-[#2E2638] transition">Tecnología</a>
          <a href="#coreadapt" className="hover:text-[#2E2638] transition">Él &amp; Ella</a>
          <a href="#anatomia" className="hover:text-[#2E2638] transition">Por dentro</a>
          <a href="#perfiles" className="hover:text-[#2E2638] transition">Para quién</a>
          <a href="#medidas" className="hover:text-[#2E2638] transition">Medidas</a>
          <a href="#tienda" className="hover:text-[#2E2638] transition">Tienda</a>
          <a href="#faq" className="hover:text-[#2E2638] transition">FAQ</a>
        </nav>
        <a
          href="#cheque"
          data-testid="header-cta"
          className="text-xs sm:text-sm uppercase tracking-wider font-bold bg-[#8B1538] text-white px-4 sm:px-5 py-2.5 hover:bg-[#6A0F2A] transition-all shadow-[0_4px_14px_rgba(139,21,56,0.35)]"
        >
          Cheque 100€
        </a>
      </div>
    </header>
  );
}

function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-gradient-to-b from-[#F9F8FA] to-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 pt-14 sm:pt-24 pb-20 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 core-fade-up">
          <div className="flex items-center gap-3 mb-5">
            <img src={LOGO} alt="" aria-hidden className="h-10 w-10 object-contain" />
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B1538] bg-[#8B1538]/8 px-3 py-1.5 border border-[#8B1538]/15">
              Promoción exclusiva tienda Navalcarnero
            </span>
          </div>
          <h1 className="font-display mt-5 text-[44px] sm:text-6xl lg:text-7xl font-extrabold leading-[1.02] tracking-tight text-[#2E2638]">
            Cada cuerpo descansa diferente. <span className="text-[#8B1538]">Core se adapta al tuyo.</span>
          </h1>
          <p className="mt-6 text-lg sm:text-xl text-[#5C5366] max-w-xl">
            Con <strong>firmeza regulable en casa</strong>, Core es el único colchón que encaja contigo — duermas solo o en pareja, entrenes duro, cargues peso o pases el día frente al ordenador. Solicita tu <strong>cheque de 100 €</strong> y ven a probarlo en nuestra tienda de Navalcarnero.
          </p>

          <div className="mt-7 flex flex-wrap gap-x-6 gap-y-3 text-sm text-[#2E2638]">
            <span className="flex items-center gap-2"><Clock size={16} className="text-[#8B1538]"/> 100 noches de prueba</span>
            <span className="flex items-center gap-2"><Award size={16} className="text-[#8B1538]"/> 10 años de garantía</span>
            <span className="flex items-center gap-2"><MapPin size={16} className="text-[#8B1538]"/> Fabricado en España</span>
            <span className="flex items-center gap-2"><Truck size={16} className="text-[#8B1538]"/> Envío y devolución gratis</span>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-4">
            <a href="#cheque" data-testid="hero-cta-primary" className="group px-7 py-4 bg-[#8B1538] text-white font-bold uppercase tracking-wider text-sm hover:bg-[#6A0F2A] transition-all shadow-[0_4px_14px_rgba(139,21,56,0.4)] hover:shadow-[0_10px_30px_rgba(139,21,56,0.45)] hover:-translate-y-0.5 flex items-center gap-2">
              Quiero mi cheque de 100€ <ArrowRight size={16} className="transition-transform group-hover:translate-x-1"/>
            </a>
            <a href="#videos" className="text-sm font-semibold text-[#2E2638] underline underline-offset-4 decoration-[#8B1538]/40 hover:decoration-[#8B1538]">
              ▶ Ver vídeo de 30 s
            </a>
            <a href="#tienda" className="text-sm font-semibold text-[#2E2638] underline underline-offset-4 decoration-[#8B1538]/40 hover:decoration-[#8B1538]">
              Ver tienda en Navalcarnero →
            </a>
          </div>

          <div className="mt-10 flex items-center gap-4">
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={18} className="fill-[#E0A500] text-[#E0A500]" />
              ))}
            </div>
            <span className="text-sm text-[#5C5366]"><strong className="text-[#2E2638]">10/10</strong> en valoraciones de clientes Core</span>
          </div>
        </div>

        <div id="cheque" className="lg:col-span-5">
          <div className="relative">
            <div aria-hidden className="pointer-events-none absolute -inset-3 bg-gradient-to-tr from-[#8B1538]/15 to-transparent blur-2xl" style={{ zIndex: 0 }} />
            <div className="relative" style={{ zIndex: 10 }}>
              <LeadForm idPrefix="hero-lead" />
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-10 pb-12">
        <div className="relative aspect-[16/7] overflow-hidden">
          <img src={HERO_IMG} alt="Colchón Core en dormitorio iluminado" className="w-full h-full object-cover" />
          <div className="absolute bottom-5 left-5 sm:bottom-8 sm:left-8 bg-white/95 backdrop-blur px-5 py-4 border border-[#E3DDE8] max-w-xs">
            <div className="text-xs uppercase tracking-[0.2em] text-[#8B1538] font-bold mb-1">Desde</div>
            <div className="flex items-baseline gap-2">
              <span className="font-display text-3xl font-extrabold text-[#8B1538]">349€</span>
              <span className="text-sm text-[#5C5366] line-through">449€</span>
            </div>
            <div className="text-xs text-[#5C5366] mt-1">Con tu cheque de 100€ canjeable en tienda.</div>
          </div>
        </div>
      </div>
    </section>
  );
}

function TrustStrip() {
  const items = [
    { icon: Clock,      title: "100 noches", sub: "de prueba en casa" },
    { icon: Award,      title: "10 años",     sub: "de garantía sin letra pequeña" },
    { icon: BadgeCheck, title: "Fabricado en España", sub: "tecnología y materiales propios" },
    { icon: Truck,      title: "Envío gratis", sub: "y devolución también gratis" },
  ];
  return (
    <section className="bg-[#2E2638] text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 py-10 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {items.map(({ icon: Icon, title, sub }, i) => (
          <div key={title} className="flex items-center gap-4" data-testid={`trust-${i}`}>
            <div className="shrink-0 w-12 h-12 flex items-center justify-center bg-white/10 border border-white/15">
              <Icon size={22} className="text-white" />
            </div>
            <div>
              <div className="font-display font-bold text-lg leading-none">{title}</div>
              <div className="text-sm text-white/70 mt-1">{sub}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function Tecnologia() {
  return (
    <section id="tecnologia" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B1538] mb-3">La diferencia Core</div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-[#2E2638] leading-tight">
            COREADAPT®:<br/>el único colchón con <span className="text-[#8B1538]">firmeza regulable</span> en casa.
          </h2>
          <p className="mt-6 text-lg text-[#5C5366]">
            En el mercado encuentras colchones duros, blandos, baratos y caros, pero <strong>ni todos somos iguales</strong> ni tenemos las mismas necesidades de descanso. Este colchón, en su <em>zona Core</em> —la cintura pélvica—, incorpora refuerzos intercambiables que <strong>tú mismo cambias en casa</strong> con absoluta facilidad y en menos de dos minutos.
          </p>
          <ul className="mt-7 space-y-3 text-[#2E2638]">
            <li className="flex items-start gap-3"><BadgeCheck className="text-[#8B1538] mt-0.5" size={20}/> Tres firmezas en un solo colchón: blanda, intermedia y firme.</li>
            <li className="flex items-start gap-3"><BadgeCheck className="text-[#8B1538] mt-0.5" size={20}/> Cada lado de la cama, a tu gusto y al de tu pareja.</li>
            <li className="flex items-start gap-3"><BadgeCheck className="text-[#8B1538] mt-0.5" size={20}/> Recibes los tres refuerzos para que pruebes hasta encontrar el tuyo.</li>
            <li className="flex items-start gap-3"><BadgeCheck className="text-[#8B1538] mt-0.5" size={20}/> 25 cm de altura, viscoelástica AIRGEL-75 transpirable, núcleo Oxigem® doble.</li>
          </ul>
          <div className="mt-9">
            <a href="#cheque" className="inline-flex items-center gap-2 px-7 py-4 bg-[#2E2638] text-white font-bold uppercase tracking-wider text-sm hover:bg-[#1f1827] transition-all">
              Pídelo con 100€ de descuento <ArrowRight size={16}/>
            </a>
          </div>
        </div>
        <div className="relative">
          <VideoCard
            src={VIDEO_TECNOLOGIA}
            title="Cómo funciona COREADAPT®"
            subtitle="Jesús Sánchez, responsable de Core, te lo explica · 1:45"
            aspect="aspect-[4/5]"
            testid="tecnologia-video"
          />
          <div className="absolute top-6 right-6 bg-white/95 px-5 py-3 border border-[#E3DDE8] shadow-sm pointer-events-none">
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#8B1538] font-bold">Patentes</div>
            <div className="text-sm font-semibold text-[#2E2638]">U2021-30321 · U2021-31816</div>
          </div>
          <div className="absolute -bottom-6 -left-6 bg-[#8B1538] text-white px-6 py-5 max-w-[260px] pointer-events-none">
            <div className="text-xs uppercase tracking-[0.2em] font-bold opacity-80">Zona Core</div>
            <div className="font-display text-xl font-bold mt-1">Regulación independiente lado a lado</div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Anatomia() {
  const layers = [
    { icon: Wind,    title: "Viscoelástica AIRGEL",       desc: "Capa superior con micropartículas de gel. Adaptable y fresca al contacto." },
    { icon: Layers,  title: "OXIGEM® High",                desc: "Núcleo intermedio con adaptación progresiva, sin atrapamiento." },
    { icon: Heart,   title: "Refuerzo lumbar (zona Core)",  desc: "Sistema patentado: tú decides la firmeza con refuerzos intercambiables." },
    { icon: BadgeCheck, title: "OXIGEM® 32",                desc: "Cimiento del colchón. Estructura compacta que aporta durabilidad." },
    { icon: Droplets,title: "Canalizaciones transversales", desc: "Evitan la condensación y mantienen el colchón fresco noche tras noche." },
    { icon: ShieldOff, title: "Funda desmontable y lavable", desc: "Tratamientos Coolfresh, antiácaros, antibacteriano y antimicrobiano. Inferior 3D antideslizante." },
  ];

  const badges = [
    { label: "Regulable",          desc: "Tres firmezas en un mismo colchón." },
    { label: "Firmeza media",      desc: "El equilibrio que más gusta a adultos y adolescentes." },
    { label: "Progresivo",         desc: "Triple núcleo con adaptación gradual." },
    { label: "Anatómico",          desc: "Núcleo zonal que respeta las formas del cuerpo." },
    { label: "Fresco y transpirable", desc: "Núcleos de poro abierto + VISCO AIRGEL 75." },
  ];

  return (
    <section id="anatomia" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-10">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B1538] mb-3">Core por dentro</div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-[#2E2638] leading-tight">
            Capas que <span className="text-[#8B1538]">trabajan para tu descanso</span>.
          </h2>
          <p className="mt-5 text-lg text-[#5C5366]">
            Cada capa de Core tiene una misión. Juntas, hacen un colchón <strong>regulable, anatómico, fresco y duradero</strong>. Esto es lo que ves cuando lo abres por dentro.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-12 gap-10 items-start">
          {/* Imagen GRANDE del corte del colchón */}
          <div className="lg:col-span-12">
            <div className="relative bg-gradient-to-br from-[#F9F8FA] to-[#F0EDF4] border border-[#E3DDE8] p-4 sm:p-12">
              <img
                src={ANATOMY_IMG}
                alt="Sección del colchón Core con todas sus capas: viscoelástica AIRGEL, OXIGEM High, anatómico zonal, OXIGEM 32, refuerzo lumbar y funda con tratamientos Coolfresh, antiácaros, antibacteriano y antimicrobiano"
                className="w-full h-auto max-w-5xl mx-auto block"
                loading="lazy"
                data-testid="anatomy-image"
              />
              <div className="absolute top-4 left-4 sm:top-8 sm:left-8 bg-white/95 backdrop-blur px-4 py-2 border border-[#E3DDE8] text-[10px] uppercase tracking-[0.2em] font-bold text-[#8B1538] hidden sm:block">
                Patentes U2021-30321 · U2021-31816
              </div>
              <div className="absolute bottom-4 right-4 sm:bottom-8 sm:right-8 bg-[#8B1538] text-white px-4 py-3 hidden sm:block">
                <div className="text-[10px] uppercase tracking-[0.2em] font-bold opacity-80">Altura</div>
                <div className="font-display text-lg font-bold">25 cm</div>
              </div>
            </div>
          </div>

          {/* Capas en 3 columnas debajo */}
          <div className="lg:col-span-12">
            <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-7 mt-4">
              {layers.map(({ icon: Icon, title, desc }, i) => (
                <li key={title} className="flex gap-4 group" data-testid={`anatomy-layer-${i}`}>
                  <div className="shrink-0 w-11 h-11 flex items-center justify-center bg-[#8B1538]/10 text-[#8B1538] group-hover:bg-[#8B1538] group-hover:text-white transition-colors">
                    <Icon size={20} />
                  </div>
                  <div>
                    <div className="font-display font-bold text-[#2E2638] text-base">{title}</div>
                    <div className="text-[#5C5366] text-sm mt-1">{desc}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {badges.map((b, i) => (
            <div key={b.label} data-testid={`anatomy-badge-${i}`} className="bg-[#F9F8FA] border border-[#E3DDE8] p-5 text-center hover:border-[#8B1538] transition-colors">
              <div className="font-display font-bold text-[#8B1538] uppercase tracking-wider text-xs mb-2">{b.label}</div>
              <div className="text-[#5C5366] text-sm leading-snug">{b.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CoreAdaptStory() {
  const profiles = [
    {
      icon: Heart,
      tag: "Para ella",
      title: "La cadera pide su sitio.",
      desc: "Por anatomía, la cadera de una mujer suele ser más prominente. La zona Core algo más blanda permite que se acomode sin que la columna pierda su línea natural.",
    },
    {
      icon: Activity,
      tag: "Para él",
      title: "Más torso, más zona Core.",
      desc: "En un hombre, el peso se concentra en la parte alta del cuerpo. La zona Core con un refuerzo más firme evita que se hunda y mantiene la postura cómoda toda la noche.",
    },
    {
      icon: Users,
      tag: "Para parejas",
      title: "Cada lado, su firmeza.",
      desc: "En medidas grandes, cada lado de la cama regula su firmeza por separado. Y la viscoelástica de calidad da independencia de movimiento: tu pareja se mueve y tú no te enteras.",
    },
  ];

  return (
    <section id="coreadapt" className="py-24 sm:py-32 bg-[#F0EDF4] relative overflow-hidden">
      <img src={LOGO} alt="" aria-hidden className="absolute -right-32 top-10 w-[420px] h-[420px] object-contain opacity-[0.04] pointer-events-none select-none" />
      <div className="max-w-7xl mx-auto px-5 sm:px-10 relative">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B1538] mb-3">¿Por qué COREADAPT®?</div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-[#2E2638] leading-tight">
            Hecho para él.<br/>Hecho para ella.<br/><span className="text-[#8B1538]">Hecho para vosotros.</span>
          </h2>
          <p className="mt-5 text-lg text-[#5C5366]">
            La anatomía nos hace distintos. Por eso un mismo colchón puede sentar de maravilla a uno y dejar al otro toda la noche dando vueltas. <strong>COREADAPT® regula esa diferencia</strong> en la zona que más manda: la cintura pélvica.
          </p>
        </div>

        {/* Dato destacado */}
        <div className="mt-10 bg-[#2E2638] text-white px-6 sm:px-10 py-7 flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-8 relative overflow-hidden" data-testid="coreadapt-stat">
          <img src={LOGO} alt="" aria-hidden className="absolute -right-6 -bottom-6 w-40 h-40 object-contain opacity-[0.08] pointer-events-none select-none" />
          <div className="font-display text-6xl sm:text-7xl font-extrabold text-[#E2B6C5] leading-none shrink-0">50%</div>
          <div className="text-base sm:text-lg leading-snug max-w-2xl">
            del peso de tu cuerpo recae sobre la <strong>zona Core</strong> (cintura pélvica) cuando estás tumbado.
            <span className="block text-white/70 text-sm mt-1">Es la zona que decide cómo descansas — y la única que puedes regular en tu Core.</span>
          </div>
        </div>

        {/* 3 perfiles */}
        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {profiles.map(({ icon: Icon, tag, title, desc }, i) => (
            <article key={title} data-testid={`coreadapt-profile-${i}`} className="bg-white border border-[#E3DDE8] p-7 hover:shadow-[0_20px_60px_rgba(46,38,56,0.08)] hover:-translate-y-1 transition-all duration-300">
              <div className="flex items-center gap-2 mb-5">
                <div className="w-10 h-10 bg-[#8B1538]/10 text-[#8B1538] flex items-center justify-center">
                  <Icon size={18} />
                </div>
                <div className="text-[11px] uppercase tracking-[0.18em] font-bold text-[#8B1538]">{tag}</div>
              </div>
              <h3 className="font-display text-xl sm:text-2xl font-bold text-[#2E2638] leading-snug">{title}</h3>
              <p className="mt-3 text-[#5C5366] text-[15px]">{desc}</p>
            </article>
          ))}
        </div>

        {/* Bloque "Si cambias, Core cambia contigo" */}
        <div className="mt-14 grid lg:grid-cols-12 gap-10 items-center bg-white border border-[#E3DDE8] p-8 sm:p-12">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B1538] mb-3">Si cambias, Core cambia contigo</div>
            <h3 className="font-display text-3xl sm:text-4xl font-bold text-[#2E2638] leading-tight">
              Tu cuerpo no es el mismo a los 30 que a los 50.<br/><span className="text-[#8B1538]">Tu colchón tampoco debería serlo.</span>
            </h3>
            <p className="mt-5 text-[#5C5366] text-lg">
              Subimos de peso, lo bajamos, dormimos solos, dormimos en pareja, cambiamos de postura. La gama Core cambia las reglas del juego: en lugar de un colchón que vale para todos, te propone un colchón <strong>que se adapta a cada uno y que evoluciona contigo</strong>.
            </p>
            <ul className="mt-6 space-y-3 text-[#2E2638]">
              <li className="flex items-start gap-3"><BadgeCheck className="text-[#8B1538] mt-0.5 shrink-0" size={20}/> Cambias el refuerzo en casa, con facilidad, en menos de dos minutos.</li>
              <li className="flex items-start gap-3"><BadgeCheck className="text-[#8B1538] mt-0.5 shrink-0" size={20}/> Tantas veces como quieras durante la vida útil del colchón.</li>
              <li className="flex items-start gap-3"><BadgeCheck className="text-[#8B1538] mt-0.5 shrink-0" size={20}/> Un solo colchón para los cambios que vendrán: ahorras y descansas mejor.</li>
            </ul>
            <a href="#cheque" data-testid="coreadapt-cta" className="mt-8 inline-flex items-center gap-2 px-7 py-4 bg-[#8B1538] text-white font-bold uppercase tracking-wider text-sm hover:bg-[#6A0F2A] transition-all shadow-[0_4px_14px_rgba(139,21,56,0.35)]">
              Pídelo con tu cheque de 100€ <ArrowRight size={16}/>
            </a>
          </div>
          <div className="lg:col-span-5">
            <div className="bg-[#F0EDF4] aspect-square flex items-center justify-center p-10 relative overflow-hidden">
              <img src={LOGO} alt="" aria-hidden className="absolute inset-0 w-full h-full object-contain opacity-[0.08] p-12 pointer-events-none select-none" />
              <div className="relative text-center">
                <div className="font-display text-7xl sm:text-8xl font-extrabold text-[#8B1538] leading-none">3</div>
                <div className="font-display text-xl font-bold text-[#2E2638] mt-3 uppercase tracking-wider">Firmezas</div>
                <div className="text-sm text-[#5C5366] mt-1">en un solo colchón</div>
                <div className="mt-6 flex items-center justify-center gap-2">
                  <span className="px-3 py-1.5 bg-white border border-[#E3DDE8] text-[11px] uppercase tracking-wider font-bold text-[#2E2638]">Blanda</span>
                  <span className="px-3 py-1.5 bg-white border border-[#E3DDE8] text-[11px] uppercase tracking-wider font-bold text-[#2E2638]">Media</span>
                  <span className="px-3 py-1.5 bg-white border border-[#E3DDE8] text-[11px] uppercase tracking-wider font-bold text-[#2E2638]">Firme</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Personas() {
  const items = [
    {
      href: "/deportistas",
      img: PERSONA_ATHLETE, icon: Activity, tag: "Para deportistas",
      title: "Llega al entreno con la energía intacta.",
      text: "Si tu rutina exige al máximo a tu cuerpo, las horas en la cama valen oro. Core se ajusta a la firmeza que mejor te encaja para que la noche cunda y mañana despiertes listo para repetir.",
    },
    {
      href: "/parejas",
      img: PERSONA_COUPLE, icon: Users, tag: "Para parejas",
      title: "Tú más blando, tu pareja más firme. Mismo colchón.",
      text: "En medidas grandes cada lado regula su firmeza por separado. Sin renunciar al gusto de nadie. Y la viscoelástica de calidad ofrece independencia de lechos: no notarás los movimientos.",
    },
    {
      href: "/esfuerzo",
      img: PERSONA_WAREHOUSE, icon: Package, tag: "Para quien carga peso",
      title: "Mañana en pie a las seis. Que la noche cunda.",
      text: "Si tu trabajo es de almacén, taller o ruta —muchas horas de pie y cargando— la cama no puede ser otro turno extra. Core encaja con tu cuerpo donde más le pesa el día.",
    },
    {
      href: "/esfuerzo",
      img: PERSONA_RETAIL, icon: ShoppingBag, tag: "Para quien atiende público",
      title: "Ocho horas en pie. Toca recargar bien.",
      text: "Tienda, supermercado, hostelería: pasas el día atendiendo y andando. Core se adapta para que la cama te devuelva lo que el día te quita y mañana llegues con otra cara.",
    },
    {
      href: "/oficinistas",
      img: PERSONA_WORKER, icon: Briefcase, tag: "Para quien pasa el día sentado",
      title: "Apaga el día. Encaja en la cama.",
      text: "Después de muchas horas en la silla, lo que tu cuerpo busca es un colchón que ceda donde tiene que ceder y sostenga donde tiene que sostener. Esa es la idea de Core.",
    },
  ];

  return (
    <section id="perfiles" className="py-24 sm:py-32 bg-[#F9F8FA]">
      <div className="max-w-7xl mx-auto px-5 sm:px-10">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B1538] mb-3">Para todos. Y para ti en particular.</div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-[#2E2638] leading-tight">
            Un colchón que <span className="text-[#8B1538]">se adapta a tu vida</span>, no al revés.
          </h2>
          <p className="mt-5 text-lg text-[#5C5366]">
            Cada persona descansa diferente. Por eso Core te deja decidir cómo te sientes mejor. Elige tu perfil y descubre cómo Core encaja contigo:
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(({ href, img, icon: Icon, tag, title, text }, i) => (
            <Link
              to={href}
              key={`${tag}-${i}`}
              data-testid={`persona-${i}`}
              className="bg-white border border-[#E3DDE8] hover:border-[#8B1538] hover:shadow-[0_20px_60px_rgba(46,38,56,0.12)] hover:-translate-y-1 transition-all duration-300 group flex flex-col focus:outline-none focus:ring-2 focus:ring-[#8B1538] focus:ring-offset-2"
            >
              <div className="relative aspect-[5/4] overflow-hidden">
                <img src={img} alt={tag} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute top-4 left-4 bg-white/95 px-3 py-1.5 text-[11px] uppercase tracking-[0.18em] font-bold text-[#8B1538] flex items-center gap-1.5">
                  <Icon size={12}/> {tag}
                </div>
              </div>
              <div className="p-7 flex-1 flex flex-col">
                <h3 className="font-display text-2xl font-bold text-[#2E2638] leading-snug">{title}</h3>
                <p className="mt-3 text-[#5C5366] text-[15px] flex-1">{text}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-[#8B1538] font-bold uppercase tracking-wider text-xs group-hover:gap-2.5 transition-all">
                  Más información <ArrowRight size={14}/>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function CinematicBanner() {
  return (
    <section
      data-testid="cinematic-banner"
      className="relative w-full overflow-hidden"
      style={{ minHeight: "720px" }}
    >
      {/* Imagen de fondo */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BEDROOM_IMG})` }}
        aria-hidden
      />
      {/* Capa base oscura global */}
      <div
        className="absolute inset-0"
        style={{ background: "rgba(15,10,20,0.45)" }}
        aria-hidden
      />
      {/* Gradiente cinematográfico izquierda → derecha */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to right, rgba(15,10,20,0.96) 0%, rgba(15,10,20,0.88) 40%, rgba(15,10,20,0.55) 70%, rgba(15,10,20,0.25) 100%)",
        }}
        aria-hidden
      />
      {/* Suave oscurecido inferior para legibilidad del CTA en móvil */}
      <div
        className="absolute inset-0 lg:hidden"
        style={{
          background:
            "linear-gradient(to top, rgba(15,10,20,0.9) 0%, rgba(15,10,20,0.55) 60%, rgba(15,10,20,0) 100%)",
        }}
        aria-hidden
      />

      {/* Contenido */}
      <div className="relative max-w-7xl mx-auto px-5 sm:px-10 pt-10 sm:pt-12 pb-24 sm:pb-28 lg:pb-32 min-h-[720px] flex flex-col">
        {/* Logo grande centrado arriba */}
        <div className="w-full flex justify-center mb-12 sm:mb-16">
          <img
            src={LOGO_WIDE}
            alt="CORE Colchón"
            data-testid="cinematic-logo"
            className="h-24 sm:h-32 lg:h-40 w-auto object-contain"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </div>

        {/* Bloque de texto */}
        <div className="max-w-3xl text-white flex-1 flex flex-col justify-center">
          <div className="flex items-center gap-3 mb-7">
            <span className="text-xs uppercase tracking-[0.25em] font-bold text-white/85 border border-white/30 px-3.5 py-2">
              Hecho en España · 100 noches de prueba
            </span>
          </div>

          <h2 className="font-display text-5xl sm:text-7xl lg:text-[88px] font-extrabold leading-[1.02] tracking-tight">
            Hay un colchón hecho para ti.<br/>
            <span className="text-[#E2B6C5]">Y también para tu pareja.</span>
          </h2>

          <p className="mt-6 text-2xl sm:text-3xl lg:text-[34px] text-white font-display font-semibold leading-[1.15] max-w-3xl">
            El único colchón con firmeza lumbar <span className="text-[#E2B6C5] uppercase tracking-wide">regulable</span> que se adapta a tu cuerpo para conseguir el descanso reparador que te mereces.
          </p>

          <p className="mt-7 text-xl sm:text-2xl lg:text-[26px] text-white/85 max-w-2xl leading-snug">
            <strong className="text-white">Cada lado, su firmeza.</strong> Tú y tu pareja elegís —de forma independiente— la firmeza que mejor se ajusta a la anatomía de cada uno. Cero discusiones por el colchón.
            <br className="hidden sm:block"/>
            Pruébalo <strong className="text-white">100 noches en casa</strong>: si no te convence, lo devuelves <strong className="text-white">totalmente gratis</strong>.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-5">
            <a
              href="#cheque"
              data-testid="cinematic-cta"
              className="group inline-flex items-center gap-2 px-8 py-5 bg-[#8B1538] hover:bg-[#6A0F2A] text-white font-bold uppercase tracking-wider text-base transition-all shadow-[0_8px_24px_rgba(139,21,56,0.45)] hover:-translate-y-0.5"
            >
              Quiero mi cheque de 100€
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1"/>
            </a>
            <a
              href="#coreadapt"
              className="text-base font-semibold text-white/90 underline underline-offset-4 decoration-[#E2B6C5]/50 hover:decoration-[#E2B6C5]"
            >
              Cómo funciona la regulación →
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-7 gap-y-3 text-sm sm:text-base text-white/85">
            <span className="flex items-center gap-2"><Award size={17} className="text-[#E2B6C5]"/> 10 años de garantía</span>
            <span className="flex items-center gap-2"><Truck size={17} className="text-[#E2B6C5]"/> Envío y devolución gratis</span>
            <span className="flex items-center gap-2"><BadgeCheck size={17} className="text-[#E2B6C5]"/> Tres firmezas en uno</span>
          </div>
        </div>
      </div>
    </section>
  );
}

function Medidas() {
  return (
    <section id="medidas" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B1538] mb-3">Medidas y precio</div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-[#2E2638] leading-tight">
            Desde <span className="line-through text-[#5C5366] font-bold">449€</span><br/>
            <span className="text-[#8B1538]">349€</span> con tu cheque.
          </h2>
          <p className="mt-5 text-lg text-[#5C5366]">
            Precios reales por medida — tanto en <strong>medidas estándar</strong> como en <strong>medidas especiales</strong> a medida. El cheque de 100€ <strong>resta 100€ a cualquiera de ellas</strong>.
          </p>

          <div className="mt-7 grid grid-cols-2 gap-4">
            <div className="border border-[#E3DDE8] p-5">
              <div className="text-[11px] uppercase tracking-wider text-[#8B1538] font-bold flex items-center gap-1.5"><Tag size={12}/> Tu cheque</div>
              <div className="font-display text-3xl font-extrabold text-[#2E2638] mt-1">−100€</div>
              <div className="text-xs text-[#5C5366] mt-1">En cualquier medida.</div>
            </div>
            <div className="border border-[#E3DDE8] p-5">
              <div className="text-[11px] uppercase tracking-wider text-[#8B1538] font-bold flex items-center gap-1.5"><Ruler size={12}/> Altura</div>
              <div className="font-display text-3xl font-extrabold text-[#2E2638] mt-1">25 cm</div>
              <div className="text-xs text-[#5C5366] mt-1">Núcleo + funda transpirable.</div>
            </div>
          </div>

          <a href="#cheque" data-testid="medidas-cta" className="mt-8 inline-flex items-center gap-2 px-7 py-4 bg-[#8B1538] text-white font-bold uppercase tracking-wider text-sm hover:bg-[#6A0F2A] transition-all shadow-[0_4px_14px_rgba(139,21,56,0.35)]">
            Reservar mi cheque <ArrowRight size={16}/>
          </a>
        </div>

        <div className="lg:col-span-7">
          <div className="border border-[#E3DDE8]">
            <div className="px-6 py-4 border-b border-[#E3DDE8] bg-[#F9F8FA] flex items-center justify-between flex-wrap gap-2">
              <div className="font-display font-bold text-[#2E2638]">Tarifa medidas estándar</div>
              <div className="text-xs text-[#5C5366]">Entrega 2–5 días laborables</div>
            </div>
            <div className="grid grid-cols-12 px-5 py-3 border-b border-[#E3DDE8] bg-white text-[10px] uppercase tracking-[0.18em] font-bold text-[#5C5366]">
              <div className="col-span-5 sm:col-span-4">Medida</div>
              <div className="col-span-3 sm:col-span-3 text-right">Precio</div>
              <div className="col-span-4 sm:col-span-5 text-right text-[#8B1538]">Con tu cheque</div>
            </div>
            <ul>
              {STANDARD_PRICES.map(({ size, price }, i) => (
                <li
                  key={size}
                  data-testid={`price-row-${i}`}
                  className="grid grid-cols-12 items-baseline px-5 py-3.5 border-b border-[#E3DDE8] hover:bg-[#F9F8FA] transition-colors"
                >
                  <div className="col-span-5 sm:col-span-4 text-[#2E2638] font-medium">{size} cm</div>
                  <div className="col-span-3 sm:col-span-3 text-right text-[#5C5366] line-through tabular-nums">{price}€</div>
                  <div className="col-span-4 sm:col-span-5 text-right">
                    <span className="font-display font-extrabold text-[#8B1538] text-lg sm:text-xl tabular-nums">{price - 100}€</span>
                  </div>
                </li>
              ))}
            </ul>
            <div className="px-6 py-4 bg-[#F9F8FA] text-sm text-[#5C5366]">
              <strong className="text-[#2E2638]">Medidas especiales</strong> (a medida): desde 67,5×180 hasta 200×200 cm. Plazo 10–15 días laborables. Pídenos el precio exacto con tu cheque.
            </div>
          </div>

          <div className="mt-6 grid sm:grid-cols-2 gap-4">
            <div className="p-5 border border-[#E3DDE8] bg-white flex items-start gap-3">
              <Bed className="text-[#8B1538] mt-0.5" size={22}/>
              <div>
                <div className="font-bold text-[#2E2638]">¿Qué refuerzo elijo?</div>
                <div className="text-sm text-[#5C5366] mt-1">El asesor te ayuda en tienda según tus preferencias. Sin compromiso.</div>
              </div>
            </div>
            <div className="p-5 border border-[#E3DDE8] bg-white flex items-start gap-3">
              <Heart className="text-[#8B1538] mt-0.5" size={22}/>
              <div>
                <div className="font-bold text-[#2E2638]">Pago a plazos</div>
                <div className="text-sm text-[#5C5366] mt-1">Hasta 10 meses sin intereses ni comisiones (acuerdo BBVA).</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function VideoGallery() {
  return (
    <section id="videos" className="py-24 sm:py-32 bg-[#2E2638] text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-10">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-white/70 mb-3">Vídeos cortos del producto</div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold leading-tight">
            Mira Core en acción <span className="text-[#E2B6C5]">en menos de 1 minuto</span>.
          </h2>
          <p className="mt-5 text-lg text-white/70">
            Cómo se cambia la firmeza, por qué funciona en pareja y la idea completa en treinta segundos.
            Y si te quedas con ganas de más, te esperamos en Navalcarnero con tu cheque de 100€.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          <VideoCard
            src={VIDEO_PAREJAS}
            title="Por qué Core es el colchón de las parejas"
            subtitle="Una solución para gustos y cuerpos distintos"
            aspect="aspect-video"
            accent="dark"
            testid="gallery-video-parejas"
          />
          <VideoCard
            src={VIDEO_REFUERZOS}
            title="Cómo se cambian los refuerzos"
            subtitle="Tú mismo, en casa, en menos de dos minutos"
            aspect="aspect-video"
            accent="dark"
            testid="gallery-video-refuerzos"
          />
          <VideoCard
            src={VIDEO_COMPOSICION}
            title="La composición de Core"
            subtitle="Capa a capa: lo que hay dentro del colchón"
            aspect="aspect-video"
            accent="dark"
            testid="gallery-video-composicion"
          />
          <VideoCard
            src={VIDEO_RESUMEN}
            title="La idea Core en 50 segundos"
            subtitle="Resumen + 100 días de prueba"
            aspect="aspect-video"
            accent="dark"
            testid="gallery-video-resumen"
          />
        </div>
      </div>
    </section>
  );
}

function Garantias() {
  const items = [
    { icon: Clock,      title: "100 noches en casa",  text: "Pruébalo en tu rutina real. Si no te conquista, lo recogemos y te devolvemos el 100%." },
    { icon: Award,      title: "10 años de garantía", text: "Cobertura clara contra defectos de fabricación. Sin sorpresas, sin letra pequeña." },
    { icon: BadgeCheck, title: "Fabricado en España", text: "Materiales y proveedores españoles. Generamos empleo y pagamos impuestos aquí." },
    { icon: Truck,      title: "Envío y devolución gratis", text: "En provincia de Madrid lo subimos y montamos. Si lo devuelves, también te lo recogemos sin coste." },
  ];
  return (
    <section className="py-24 sm:py-32 bg-[#F9F8FA]">
      <div className="max-w-7xl mx-auto px-5 sm:px-10">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B1538] mb-3">Cuando eliges Core puedes estar tranquil@</div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-[#2E2638] leading-tight">
            Tu compra <span className="text-[#8B1538]">sin riesgo</span>.<br/>Y nuestra palabra por delante.
          </h2>
        </div>
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map(({ icon: Icon, title, text }, i) => (
            <div key={title} data-testid={`warranty-${i}`} className="bg-white border border-[#E3DDE8] p-7 hover:shadow-[0_15px_40px_rgba(46,38,56,0.07)] transition-all">
              <div className="w-12 h-12 bg-[#8B1538]/10 flex items-center justify-center mb-5">
                <Icon size={22} className="text-[#8B1538]" />
              </div>
              <h3 className="font-display text-xl font-bold text-[#2E2638] mb-2 leading-tight">{title}</h3>
              <p className="text-sm text-[#5C5366]">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function BrandStrip() {
  return (
    <section className="py-16 sm:py-20 bg-white border-y border-[#E3DDE8] relative overflow-hidden">
      {/* Marca de agua del logo */}
      <img
        src={LOGO}
        alt=""
        aria-hidden
        className="absolute -left-24 -top-24 w-[360px] h-[360px] object-contain opacity-[0.04] pointer-events-none select-none"
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-10 relative">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 text-center lg:text-left">
          <div className="flex flex-col lg:flex-row items-center gap-5 sm:gap-7">
            <img src={LOGO_WIDE} alt="Core Colchón" className="h-20 sm:h-24 lg:h-28 w-auto object-contain shrink-0" data-testid="brandstrip-logo"/>
            <div>
              <div className="text-[#5C5366] text-sm sm:text-base max-w-md">Más de 70 años fabricando descanso. Tecnología COREADAPT® patentada en España.</div>
            </div>
          </div>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
            <span className="px-4 py-2 bg-[#F9F8FA] border border-[#E3DDE8] text-xs uppercase tracking-wider font-bold text-[#2E2638]">100 noches prueba</span>
            <span className="px-4 py-2 bg-[#F9F8FA] border border-[#E3DDE8] text-xs uppercase tracking-wider font-bold text-[#2E2638]">10 años garantía</span>
            <span className="px-4 py-2 bg-[#F9F8FA] border border-[#E3DDE8] text-xs uppercase tracking-wider font-bold text-[#2E2638]">Envío gratis</span>
            <span className="px-4 py-2 bg-[#8B1538] text-xs uppercase tracking-wider font-bold text-white">★ 4,7 · Google</span>
          </div>
        </div>
      </div>
    </section>
  );
}

const WHATSAPP_LINK = "https://api.whatsapp.com/send?phone=34630666734&text=Quiero%20mi%20cup%C3%B3n%20descuento%20de%20100%E2%82%AC";

function WhatsAppCTA() {
  return (
    <section id="whatsapp" className="py-20 sm:py-28 bg-emerald-600 text-white relative overflow-hidden">
      <div aria-hidden className="absolute -top-32 -right-32 w-96 h-96 bg-emerald-500/40 rounded-full blur-3xl"/>
      <div aria-hidden className="absolute -bottom-40 -left-32 w-[28rem] h-[28rem] bg-emerald-700/40 rounded-full blur-3xl"/>
      <div className="relative max-w-7xl mx-auto px-5 sm:px-10 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur px-4 py-2 text-xs uppercase tracking-[0.2em] font-bold mb-5">
            <MessageCircle size={14}/> Atajo por WhatsApp
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight">
            ¿Prefieres pedirlo por WhatsApp?<br/>
            <span className="text-emerald-100">También vale.</span>
          </h2>
          <p className="mt-6 text-lg text-emerald-50/90 max-w-2xl">
            Si no te apetece rellenar formularios, escríbenos directamente a WhatsApp. Te enviamos tu <strong>cheque de 100€</strong> y coordinamos contigo la visita a la tienda de Navalcarnero. Sin compromiso.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-x-7 gap-y-3 text-sm text-emerald-50/90">
            <span className="flex items-center gap-2"><Zap size={16}/> Respuesta en minutos</span>
            <span className="flex items-center gap-2"><ShieldCheck size={16}/> Cheque por WhatsApp o email</span>
            <span className="flex items-center gap-2"><Clock size={16}/> En horario de tienda</span>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-section-cta"
              className="group px-7 py-4 bg-white text-emerald-700 font-bold uppercase tracking-wider text-sm hover:bg-emerald-50 transition-all shadow-[0_6px_20px_rgba(0,0,0,0.18)] hover:-translate-y-0.5 flex items-center gap-2"
            >
              <MessageCircle size={18}/> Abrir chat de WhatsApp
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1"/>
            </a>
            <a
              href="tel:+34630666734"
              data-testid="whatsapp-section-call"
              className="px-5 py-4 border border-white/30 hover:bg-white/10 text-sm font-bold uppercase tracking-wider flex items-center gap-2"
            >
              <Phone size={16}/> +34 630 66 67 34
            </a>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="bg-white text-[#2E2638] p-6 sm:p-8 shadow-[0_20px_60px_rgba(0,0,0,0.25)] relative">
            <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-emerald-700 mb-3">Cómo funciona</div>
            <ol className="space-y-4">
              {[
                { n: "1", t: "Pulsa el botón de WhatsApp.", d: "Se abre tu app con un mensaje ya escrito." },
                { n: "2", t: "Envía el mensaje.", d: "Te respondemos en minutos en horario de tienda." },
                { n: "3", t: "Recibes tu cheque de 100 €.", d: "Y coordinamos cuándo te viene bien venir." },
              ].map((s) => (
                <li key={s.n} className="flex items-start gap-4">
                  <span className="shrink-0 w-9 h-9 bg-emerald-600 text-white flex items-center justify-center font-display font-bold">{s.n}</span>
                  <div>
                    <div className="font-bold text-[#2E2638]">{s.t}</div>
                    <div className="text-sm text-[#5C5366] mt-0.5">{s.d}</div>
                  </div>
                </li>
              ))}
            </ol>
            <div className="mt-6 pt-5 border-t border-[#E3DDE8] text-xs text-[#5C5366]">
              <ShieldCheck size={12} className="inline -mt-0.5 mr-1 text-emerald-600"/>
              Tus datos solo se usan para coordinar tu visita.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}



function Tienda() {
  return (
    <section id="tienda" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B1538] mb-3">Tienda física · Navalcarnero</div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-[#2E2638] leading-tight">
            Te esperamos en <span className="text-[#8B1538]">Navalcarnero</span>.
          </h2>
          <p className="mt-5 text-lg text-[#5C5366]">
            Pruébalo, tócalo y deja que un asesor te lo explique con calma. Sin colas y sin presión: <strong>nos llamas, agendamos hora y vienes a tu medida</strong>.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-8 items-stretch">
          {/* Info card */}
          <div className="lg:col-span-5 bg-[#2E2638] text-white p-8 sm:p-10 flex flex-col relative overflow-hidden">
            <img
              src={LOGO}
              alt=""
              aria-hidden
              className="absolute -right-10 -bottom-10 w-56 h-56 object-contain opacity-[0.07] pointer-events-none select-none"
            />
            <div className="flex items-start gap-3 mb-6 relative">
              <img src={LOGO} alt="Core" className="h-14 w-14 object-contain bg-white p-1.5 shrink-0"/>
              <div>
                <div className="font-display text-2xl font-bold leading-snug">Tienda Core Colchón</div>
                <div className="text-white/70 text-sm">Muebles Muñoz · Navalcarnero</div>
                <div className="flex items-center gap-2 mt-1.5 text-sm">
                  <span className="text-[#E0A500] font-bold">★ 4,7</span>
                  <span className="text-white/60">· 708 reseñas en Google</span>
                </div>
              </div>
            </div>

            <ul className="space-y-4 text-white/90 flex-1 relative">
              <li className="flex gap-3">
                <MapPin className="text-[#E2B6C5] mt-0.5 shrink-0" size={18}/>
                <span>Calle Dehesa de Mari Martín, 27 (Autovía N-V)<br/>28600 Navalcarnero (Madrid)</span>
              </li>
              <li className="flex gap-3">
                <Clock className="text-[#E2B6C5] mt-0.5 shrink-0" size={18}/>
                <span>Tardes de <strong>16:30 a 20:00 h</strong></span>
              </li>
              <li className="flex gap-3">
                <Phone className="text-[#E2B6C5] mt-0.5 shrink-0" size={18}/>
                <a href="tel:+34910889962" className="hover:text-white" data-testid="tienda-phone-store">910 88 99 62</a>
                <span className="text-white/50">·</span>
                <a href="https://wa.me/34630666734?text=Hola%2C%20tengo%20mi%20cheque%20de%20100%E2%82%AC%20y%20quiero%20reservar%20cita" target="_blank" rel="noreferrer" className="text-white hover:text-[#E2B6C5] underline underline-offset-4" data-testid="tienda-whatsapp">WhatsApp</a>
              </li>
              <li className="flex gap-3">
                <Mail className="text-[#E2B6C5] mt-0.5 shrink-0" size={18}/>
                <a href="mailto:navalcarnero@munozmuebles.net" className="hover:text-white break-all" data-testid="tienda-email">navalcarnero@munozmuebles.net</a>
              </li>
            </ul>

            <div className="mt-8 grid grid-cols-2 gap-3">
              <a
                href={STORE_MAPS_LINK}
                target="_blank"
                rel="noreferrer"
                data-testid="tienda-cta-maps"
                className="px-4 py-3 bg-[#8B1538] hover:bg-[#6A0F2A] text-white font-bold uppercase tracking-wider text-xs flex items-center justify-center gap-2 transition-colors"
              >
                <Navigation size={14}/> Cómo llegar
              </a>
              <a
                href="#cheque"
                data-testid="tienda-cta"
                className="px-4 py-3 bg-white text-[#2E2638] hover:bg-[#E2B6C5] font-bold uppercase tracking-wider text-xs flex items-center justify-center gap-2 transition-colors"
              >
                Mi cheque 100€ <ArrowRight size={14}/>
              </a>
            </div>
          </div>

          {/* Google Maps embed */}
          <div className="lg:col-span-7 relative min-h-[420px] border border-[#E3DDE8]">
            <iframe
              title="Ubicación tienda Core Colchón en Navalcarnero"
              src={STORE_MAPS_EMBED}
              className="absolute inset-0 w-full h-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              data-testid="tienda-maps-iframe"
            />
            <a
              href={STORE_MAPS_LINK}
              target="_blank"
              rel="noreferrer"
              className="absolute top-3 right-3 bg-white px-3 py-2 text-xs font-bold uppercase tracking-wider text-[#2E2638] hover:bg-[#8B1538] hover:text-white transition-colors flex items-center gap-1.5 shadow-md"
              data-testid="tienda-maps-open"
            >
              Abrir en Google Maps <ExternalLink size={12}/>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function Testimonios() {
  const loop = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section className="py-24 sm:py-28 bg-[#F0EDF4] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 mb-10 flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B1538] mb-3">Lo que opinan los clientes Core</div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-[#2E2638] leading-tight">
            <span className="text-[#8B1538]">10/10</span> en valoraciones.
          </h2>
        </div>
        <div className="flex items-center gap-3 text-sm text-[#5C5366]">
          <StarRow n={5}/> · Reseñas reales de clientes
        </div>
      </div>

      <div className="relative">
        <div className="flex w-max core-marquee gap-5">
          {loop.map((t, i) => (
            <article key={`${t.name}-${i}`} data-testid={`testimonial-${i}`} className="w-[340px] shrink-0 bg-white border border-[#E3DDE8] p-6">
              <Quote className="text-[#8B1538]/30" />
              <p className="mt-3 text-[15px] text-[#2E2638] leading-relaxed">{t.text}</p>
              <div className="mt-5 flex items-center justify-between">
                <div className="font-bold text-[#2E2638]">{t.name}</div>
                <StarRow n={t.stars} />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQ() {
  return (
    <section id="faq" className="py-24 sm:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-5 sm:px-10">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B1538] mb-3 text-center">Preguntas frecuentes</div>
        <h2 className="font-display text-4xl sm:text-5xl font-bold text-[#2E2638] leading-tight text-center">
          Lo que necesitas saber antes de venir.
        </h2>
        <div className="mt-12">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`f-${i}`} className="border-b border-[#E3DDE8]">
                <AccordionTrigger className="text-left font-display text-lg sm:text-xl font-semibold text-[#2E2638] hover:no-underline py-6" data-testid={`faq-trigger-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#5C5366] text-base pb-6 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}

function FinalCTA() {
  return (
    <section className="py-24 sm:py-32 bg-[#2E2638] text-white relative overflow-hidden">
      {/* Logo decorativo grande en el fondo */}
      <img
        src={LOGO}
        alt=""
        aria-hidden
        className="absolute -right-20 -bottom-20 w-[460px] h-[460px] object-contain opacity-[0.06] pointer-events-none select-none"
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-10 grid lg:grid-cols-12 gap-12 items-center relative">
        <div className="lg:col-span-7">
          <img src={LOGO_WIDE} alt="Core Colchón" className="h-14 w-auto object-contain mb-7" style={{ filter: "brightness(0) invert(1)" }} />
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-white/70 mb-3">Última llamada</div>
          <h2 className="font-display text-4xl sm:text-6xl font-bold leading-[1.05]">
            100€ menos. <span className="text-[#E2B6C5]">100 noches de prueba.</span><br/>0 riesgo.
          </h2>
          <p className="mt-6 text-lg text-white/75 max-w-xl">
            Solicita tu cheque y ven a conocer Core en nuestra tienda de Navalcarnero. Si una vez probado te convence, te lo llevas a casa con la tranquilidad de las <strong>100 noches de prueba</strong>: o duermes mejor que nunca, o nos lo devuelves <strong>sin letra pequeña</strong>.
          </p>
        </div>
        <div className="lg:col-span-5">
          <LeadForm idPrefix="final-lead" variant="dark" />
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="bg-[#1f1827] text-white/70 text-sm">
      <div className="max-w-7xl mx-auto px-5 sm:px-10 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <img src={LOGO_WIDE} alt="Core Colchón" className="h-16 w-auto object-contain mb-5" style={{ filter: "brightness(0) invert(1)" }} />
          <p className="text-white/60">El único colchón con firmeza regulable. Fabricado en España.</p>
        </div>
        <div>
          <div className="font-display font-bold text-white mb-3">Tienda Navalcarnero</div>
          <p>Calle Dehesa de Mari Martín, 27 (Autovía N-V)<br/>28600 Navalcarnero (Madrid)<br/>Tardes 16:30 – 20:00 h<br/>★ 4,7 · 708 reseñas</p>
        </div>
        <div>
          <div className="font-display font-bold text-white mb-3">Contacto</div>
          <p>Tienda: 910 88 99 62<br/>WhatsApp: 630 66 67 34<br/>navalcarnero@munozmuebles.net</p>
        </div>
        <div>
          <div className="font-display font-bold text-white mb-3">Empresa</div>
          <p>Muebles de Siempre S.L.<br/>Crtra. de Extremadura 8<br/>45513 Santa Cruz del Retamar (Toledo)<br/>C.I.F. B-83146654</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-10 py-5 flex flex-wrap justify-between text-xs text-white/50 gap-3">
          <span>© {new Date().getFullYear()} CORE COLCHÓN — Todos los derechos reservados.</span>
          <span id="privacidad" className="flex flex-wrap gap-x-3 gap-y-1">
            <Link to="/aviso-legal" data-testid="footer-aviso-legal" className="hover:text-white transition-colors">Aviso legal</Link>
            <span aria-hidden>·</span>
            <Link to="/privacidad" data-testid="footer-privacidad" className="hover:text-white transition-colors">Política de privacidad</Link>
            <span aria-hidden>·</span>
            <Link to="/cookies" data-testid="footer-cookies" className="hover:text-white transition-colors">Cookies</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}

export default function Landing() {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/site-config`);
        if (cancelled) return;
        const pixelId = (res.data?.meta_pixel_id || "").trim();
        if (pixelId && !window._fbqLoaded) {
          window._fbqLoaded = true;
          // Meta Pixel base code
          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
          window.fbq('init', pixelId);
          // Generate a shared event_id for PageView so CAPI can dedupe
          const eid = (window.crypto?.randomUUID?.() || String(Math.random()));
          window.__pv_event_id = eid;
          window.fbq('track', 'PageView', {}, { eventID: eid });
          // Server-side PageView (CAPI)
          try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/public/track/pageview`, {
              event_id: eid,
              page_url: window.location.href,
              fbp: document.cookie.match(/_fbp=([^;]+)/)?.[1],
              fbc: document.cookie.match(/_fbc=([^;]+)/)?.[1],
            });
          } catch (error) {
            console.warn("CAPI PageView tracking failed:", error);
          }
        }
      } catch (error) {
        console.warn("Site config fetch failed (tracking disabled):", error);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="landing-page">
      <Header />
      <CinematicBanner />
      <Personas />
      <Hero />
      <TrustStrip />
      <Tecnologia />
      <CoreAdaptStory />
      <Anatomia />
      <Medidas />
      <VideoGallery />
      <Garantias />
      <BrandStrip />
      <Tienda />
      <Testimonios />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
